export default __webpack_public_path__ + "static/media/d28.a1c9d52c.jpeg";